import { AlertModal } from '@components/Modal';
import { IconButton } from '@mui/material';
import QuestionIcon from '@mui/icons-material/HelpRounded';
import { useState } from 'react';
import { styled } from '@mui/system';

const QuestionIconButton = styled(IconButton)({
  padding: 1,
  width: '24px',
  height: '24px',
});
interface PriceComparatorInfoModalProps {
  lastUpdate?: string;
}
export function PriceComparatorInfoModal({
  lastUpdate,
}: PriceComparatorInfoModalProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <QuestionIconButton onClick={() => setOpen(true)} size="large">
        <QuestionIcon />
      </QuestionIconButton>

      <AlertModal
        open={open}
        setOpen={setOpen}
        AlignContentLeft={true}
        title="Precios online"
        content={`Buscamos los productos en farmaciasahumada.cl, cruzverde.cl, salcobrand.cl y drsimi.cl y te mostramos los precios de lista y los descuentos generales de los que logramos encontrar.

Los descuentos pueden cambiar según el día de la semana, el convenio del cliente y/o el medio de pago.

Si un producto no lo encontramos no significa que no exista en esas farmacias.

${
  lastUpdate
    ? `Los precios que mostramos fueron actualizados por última vez el ${lastUpdate}. Pueden haber variado desde entonces.`
    : ''
}`}
        actions={[
          {
            onActionClick: () => {
              setOpen(false);
            },
            text: 'Ok',
          },
        ]}
      />
    </>
  );
}
